//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';

import EditableName from '@components/atoms/editable-name/EditableName';
import { useBoundActionCreators } from '@hooks/useCuralateStore';
import { toastNotificationsActions } from '@legacy-components/common/toast-notifications/toastNotificationsActions';
import { ToastType } from '@legacy-components/common/toast-notifications/toastNotificationsModel';
import { IStream } from '@streams-drawer/model/IStream';
import { StreamsDrawerTrackingIds } from '@streams-drawer/streams-drawer-constants';
import { streamCreationActions } from '@streams/actions/streamCreationActions';

const EditableStreamName = () => {
  const { addToastNotification } = useBoundActionCreators(
    toastNotificationsActions,
  );
  const hasFanreelManagePermission = useSelector(
    (state) => state.session.permissions['fanreel:manage'],
  );
  const streams = useSelector((state) => state.streams.streamsDrawer.streams);
  const selectedStream = useSelector(
    (state) => state.streams.streamsDrawer.selectedStream,
  );
  const { updateStreamName } = useBoundActionCreators(streamCreationActions);

  const saveStreamName = async (name: string) => {
    const otherStreamNames = streams
      .filter((stream: IStream) => stream.id !== selectedStream.id)
      .map((stream: IStream) => stream.name);

    const isDuplicateName = otherStreamNames.some(
      (otherName) => otherName === name,
    );

    // Don't update if duplicate
    if (isDuplicateName) {
      addToastNotification({
        title: 'Another stream already has this name. Please try again.',
        type: ToastType.ERROR,
      });
    } else {
      await updateStreamName(name);
      addToastNotification({
        title: 'Changes saved',
        type: ToastType.SUCCESS,
      });
    }
  };

  return (
    <EditableName
      trackingId={StreamsDrawerTrackingIds.STREAMS_DRAWER_PAGE_HEADER_NAME}
      centerText={true}
      isDisabled={!hasFanreelManagePermission}
      name={selectedStream.name}
      onSaveName={saveStreamName}
      placeholder='Enter a Stream name'
      disabledTooltip={`
        You don't have permission to edit this Stream name. Contact a group admin if this is a mistake.
      `}
      maxLength={50}
    />
  );
};

export default EditableStreamName;
